<template>
  <div class="layer-tem">
    <!-- 关闭按钮 -->
    <img 
        :src="newClose"
        class="close-btn" 
        alt=""
        @click="closeLayer"
    >
    <!-- 主内容 -->
    <div class="layer-main">
      <!-- 导航 -->
      <tab-nav :tabArr="tabArr" :parNavIndex="tabIndex" @index="tabIndexFn"></tab-nav>
      <!-- 块 -->
      <div class="block-list">
        <div class="block-head">
          <!-- 标题 -->
          <div class="tit">
            近30天警情历史趋势
          </div>
          <!-- 下拉框 -->
          <div class="select-wrap">
            <Select 
              v-model="areaId"
              transfer 
              :word-wrap="true"
              clearable
              style="width: 100px;margin-right: 10px;"
              placeholder="区域"
              @on-change="formChange"
              v-show="tabIndex == 0"
            >
              <Option
                v-for="item in areaArr"
                :value="item.sid"
                :key="item.id">
                {{ item.name }}
              </Option>
            </Select>
            <Select 
              v-model="industId"
              transfer 
              :word-wrap="true"
              clearable
              style="width: 100px;"
              placeholder="行业"
              @on-change="formChange"
              v-show="tabIndex == 1"
            >
              <Option
                v-for="item in industArr"
                :value="item.value"
                :key="item.id">
                {{ item.name }}
              </Option>
            </Select>
          </div>
        </div>
        <div class="block-main">
          <!-- 列表 滚动加载更多 -->
          <div class="block-main-content">
            <!-- 周月导航 -->
            <!-- echart图 -->
            <ul class="time_nav_bar">
              <li v-for="(item, index) in typeNavArr" :key="index" :class="{'active': index == typeIndex}" @click="echartTypeNav(index)">
                {{item}}
              </li>
            </ul>
            <div class="echart" ref="echart"></div>
          </div>
        </div>
      </div>
      <!-- 块 -->
      <div class="block-list">
        <div class="block-main">
          <!-- 列表 滚动加载更多 -->
          <div class="block-main-content bot-block-wrap">
            <!-- 扇形echarts -->
            <div class="echart-wrap">
                <div class="echart-head">
                    <div class="echart-tit">
                        <p class="tit">
                            警情占比
                        </p>
                        <p>
                            {{echartDay}}
                        </p>
                        <div class="echart-btn" @click="allEchart" v-show="echartDay">
                            全部
                        </div>
                    </div>
                  <Button type="primary" @click="fanEchart" v-if="echartfan">返回</Button>
                </div>
                <div class="sector-echart" ref="sectorEchart"></div>
            </div>
            <!-- 列表 滚动加载更多 -->
            <div class="table-wrap">
                <div class="table-head">
                    <table>
                        <tr>
                            <th width="33.33%">
                              单位名称
                            </th>
                            <th width="33.33%">
                              {{sectorTit}}数量
                            </th>
                            <th width="33.33%">
                              详情
                            </th>
                        </tr>
                    </table>
                </div>
                <div class="table-body" id="leftBot">
                    <table>
                        <tr v-for="(item, index) in tableListArr" :key="index">
                            <td width="33.33%" >
                                <Poptip
                                    trigger="hover"
                                    transfer :word-wrap="true"
                                    :content="item.name"
                                    v-if="item.name"
                                >
                                    {{item.name}}
                                </Poptip>
                            </td>
                            <td width="33.33%" >
                                <Poptip
                                    trigger="hover"
                                    transfer :word-wrap="true"
                                    :content="item.count"
                                >
                                    {{item.count}}
                                </Poptip>
                            </td>
                            <td width="33.33%">
                              <span class="viewDetail" @click="showDetailLayer(item.depId)">查看</span>
                            </td>
                        </tr>
                    </table>
                    <p class="no-data" v-show="!tableListArr.length ">
                        暂无数据
                    </p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="trans_bot_modal">
        <div class="detail-layer-wrap" v-if="detailLayerId">
            <!-- 关闭按钮 -->
            <img 
                :src="close"
                class="close-btn" 
                alt=""
                @click="closeDetailLayer"
            >
            <!-- 列表 滚动加载更多 -->
            <div class="table-wrap">
                <div class="table-head">
                    <table>
                        <tr>
                            <th width="10%">
                                序号
                            </th>
                            <th width="10%">
                                单位名称
                            </th>
                            <th width="20%">
                                {{layerTit}}时间
                            </th>
                            <th width="10%">
                                设备名称
                            </th>
                            <th width="20%">
                                {{layerTit}}内容
                            </th>
                            <!-- <th width="20%">
                                安装位置
                            </th> -->
                            <th width="10%">
                                处理状态
                            </th>
                        </tr>
                    </table>
                </div>
                <div class="table-body" id="leftBot_detailLayer">
                    <table>
                        <tr v-for="(item, index) in layerTableArr" :key="index">
                            <td width="10%" >
                                {{index+1}}
                            </td>
                            <td width="10%" >
                                <Poptip
                                    trigger="hover"
                                    transfer :word-wrap="true"
                                    :content="item.orgName"
                                    v-if="item.orgName"
                                >
                                    {{item.orgName}}
                                </Poptip>
                            </td>
                            <td width="20%" >
                                <Poptip
                                    trigger="hover"
                                    transfer :word-wrap="true"
                                    :content="timestamp(item.ctime)"
                                    v-if="item.ctime"
                                >
                                    {{timestamp(item.ctime)}}
                                </Poptip>
                            </td>
                            <td width="10%" >
                                <Poptip
                                    trigger="hover"
                                    transfer :word-wrap="true"
                                    :content="item.deviceName"
                                    v-if="item.deviceName"
                                >
                                    {{item.deviceName}}
                                </Poptip>
                            </td>
                            <td width="20%" >
                                <Poptip
                                    trigger="hover"
                                    transfer :word-wrap="true"
                                    :content="item.content"
                                    v-if="item.content"
                                >
                                    {{item.content}}
                                </Poptip>
                            </td>
                            <!-- <td width="20%" >
                                <Poptip
                                    trigger="hover"
                                    transfer :word-wrap="true"
                                    :content="item.address"
                                    v-if="item.address"
                                >
                                    {{item.address}}
                                </Poptip>
                            </td> -->
                            <td width="10%" >
                                <Poptip
                                    trigger="hover"
                                    transfer :word-wrap="true"
                                    :content="item.state"
                                    v-if="item.state"
                                >
                                    {{item.state}}
                                </Poptip>
                            </td>
                        </tr>
                    </table>
                    <p class="no-data" v-show="!layerTableArr.length && getLayerStatus">
                        暂无数据
                    </p>
                </div>
            </div>
        </div>
    </transition>
  </div>
</template>
<script>
import close from '@/assets/img/close.png';
import newClose from '@/assets/img/newClose.png';
import tabNav from './tab-nav.vue';
import tableTem from './layer-table.vue';

import {themeArr} from '@/assets/js/theme.js';
import {timestampToTime} from '@/assets/js/index';
export default {
  name:"",    
  data: () => ({
    echarts_color: themeArr[0].color,
    close,
    newClose,
    tabArr: ['区域', '行业'],
    tabIndex: 0,
    typeNavArr: ['折线图', '柱状图'],
    timeArr: [],
    typeIndex: 0,
    hashValue: '',
    loginData: {},
    currentPage: 1,
    professList: [],
    professId: '',
    echartDom: null,
    getEchartStatus: false,
    getTableStatus: false,
    top_echart: null,
    bot_echart: null,
    tableTit: '',
    type:'',
    tableListArr: [],
    tableDepId: '',
    totalCount: '',
    layerTotalCount: '',
    layerTableArr: [],
    layerCurrentPage: 1,
    layerTit: '',
    getLayerStatus: false,
    areaArr: [],
    industArr: [],
    areaId: '',
    industId: '',
    echartData: {},
    echartDay: '',
    beginTime: '',
    endTime: '',
    echartClickTime: '',
    tableType: '',
    detailLayerId: '',
    sectorTit: '火警',
    echartfan:false,
      beginDate:'',
      endDate:''

  }),
  components: {
    tabNav,
    tableTem
  },
  created() {
    this.hashValue = localStorage.getItem('hashValue');
    this.loginData = JSON.parse(localStorage.getItem('loginData'));
    this.getTimeFn(); 
  },
  mounted() {
    this.getEchartData();
    this.getAreaData(); 
  },
  computed: {

  },
  methods: {
    dataInit(){
        this.echartClickTime = '';
        this.sectorTit = '火警';
        this.tableType = '';
        // 重置时间
        this.getTimeFn();
    },
    timestamp(time) {
        if(time){
            return timestampToTime(time);
        }
    },
    closeDetailLayer(){
        this.detailLayerId = '';
    },
    getLayerData(id){
        this.getLayerStatus = false;
        let url = '';
        let obj = {};
        switch (this.tableType) {
            case 'flamingFire': //火警
                this.layerTit = '火警';
                url = '/mcbw/alarm_manage/fire';
                obj = {
                    "sources":"3,6,7",
                    "pageSize":50,
                    "currentPage": this.layerCurrentPage,
                    "orgId": id,
                    "beginTime": this.echartDay?this.echartDay:this.beginTime,
                    "endTime": this.echartDay?this.echartDay:this.endTime,
                    "state":null,
                    "type":null,
                    "content":null,
                    
                }
                break;
            case 'fire': //报警
                this.layerTit = '报警';
                url = '/mcbw/alarm_manage/fire';
                obj = {
                    "pageSize":50,
                    "currentPage": this.layerCurrentPage,
                    "orgId":id,
                    "beginTime": this.echartDay?this.echartDay:this.beginTime,
                    "endTime": this.echartDay?this.echartDay:this.endTime,
                    "state":null,
                    "type":null,
                    "content":null
                }
                break;
            case 'warn': //预警
                this.layerTit = '预警';
                url = '/mcbw/alarm_manage/warn';
                obj = {
                    "pageSize":50,
                    "currentPage": this.layerCurrentPage,
                    "orgId":id,
                    "beginTime": this.echartDay?this.echartDay:this.beginTime,
                    "endTime": this.echartDay?this.echartDay:this.endTime,
                    "state":null,
                    "type":null,
                    "content":null
                }
                break;
            case 'hiddenHazard': //隐患
                this.layerTit = '隐患';
                url = '/mcbw/hidden_hazard';
                obj = {
                    "pageSize":50,
                    "currentPage": this.layerCurrentPage,
                    "orgId":id,
                    "beginTime": this.echartDay?this.echartDay:this.beginTime,
                    "endTime": this.echartDay?this.echartDay:this.endTime,
                    "state":null,
                    "type":null,
                    "content":null
                }
                break;
            case 'fault': //故障
                this.layerTit = '故障';
                url = '/mcbw/alarm_manage/fault';
                obj = {
                    "pageSize":50,
                    "currentPage": this.layerCurrentPage,
                    "orgId":id,
                    "beginTime": this.echartDay?this.echartDay:this.beginTime,
                    "endTime": this.echartDay?this.echartDay:this.endTime,
                    "state":null,
                    "type":null,
                    "content":null
                }
                break;
        }

        let dataObj = {
            type: 'get',
            url,
            obj
        }
        this.$Axios(dataObj).then((res)=>{
            console.log(res);
            console.log('表格详情');
            this.getLayerStatus = true;
            if(res.data.success){
                if(res.data.totalCount){
                    this.layerTotalCount = res.data.totalCount;
                }
                if(!res.data.data.length){
                    return;
                }
                this.layerTableArr = [...this.layerTableArr, ...res.data.data];
                let _this = this;
                this.$nextTick(()=>{
                    $JQ('#leftBot_detailLayer').mCustomScrollbar({
                        callbacks: {
                            onTotalScroll: function () {
                                if ((_this.layerTableArr.length == res.data.totalCount) || (res.data.data.length == 0)) {
                                    console.log('没有更多数据');
                                    return;
                                } else {
                                    console.log('加载更多');
                                    _this.layerCurrentPage += 1;
                                    _this.getLayerData(id);
                                }
                            }
                        }
                    });
                });
            }
        });
    },
    showDetailLayer(id){ //显示详情弹窗
        this.detailLayerId = id;
        this.layerTotalCount = '';
        this.layerTableArr = [];
        this.layerCurrentPage = 1;
        this.getLayerData(id);
    },
    formChange(){ //改变表单
        this.dataInit();
        //重新请求数据
        this.getEchartData();
    },
    getAreaData(){
      let dataObj = {
            type: 'get',
            // url: '/mcbw/areas/' + this.loginData.orgId,
            url: '/mcbw/departments/org/area',
            obj: {
                pageSize: 1000,
                currentPage: 1,
            }
        }
        this.$Axios(dataObj).then((res)=>{
            console.log(res);
            console.log('区域数据');
            if(res.data.success && res.data.data.length){
              this.areaArr = res.data.data;
            }
        });
    },
    getIndustData(){
      let dataObj = {
            type: 'get',
            url: '/mcbw/dictionary_datas/industryCategory/data',
            obj: {
                
            }
        }
        this.$Axios(dataObj).then((res)=>{
            console.log(res);
            console.log('行业数据');
            if(res.data.success && res.data.data.length){
              this.industArr = res.data.data;
            }
        });
    },
    closeLayer(){
      this.$store.commit('showLayer', {
          status: false,
          type: '',
      });
    },
    tabIndexFn(tabIndex){ //导航切换
      this.tabIndex = tabIndex; //0区域 1行业
      this.areaId = ''; //清空选择区域
      this.industId = ''; //清空选择行业
      this.dataInit();
      this.getEchartData();
      if(this.tabIndex){ //行业
        if(!this.industArr.length){
            this.getIndustData();
        }
      }else{ //区域
        if(!this.areaArr.length){
            this.getAreaData();
        }
      }
    },
    echartTypeNav(index){
      this.typeIndex = index;
      if(this.top_echart){
        this.top_echart.clear();
      }
      console.log(index);
      
      //设置折线图、柱状图
      if(this.typeIndex){ //柱状图
        this.topInit(this.echartData, 'bar');
      }else{ //折线图
        this.topInit(this.echartData);
      }
    },
    getTimeFn(){
        this.timeArr = []; //清空时间数组

        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth()+1;
        let day = date.getDate();
        let nowDate = year + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
        let lastDate = new Date(date - 1000 * 60 * 60 * 24 * 30);//最后30天可以更改，意义：是获取多少天前的时间
        let lastY = lastDate.getFullYear();
        let lastM = lastDate.getMonth()+1;
        let lastD = lastDate.getDate();
        let LDate = lastY + "-" + (lastM < 10 ? "0" + lastM : lastM) + "-" +(lastD < 10 ? "0" + lastD : lastD);//得到30天前的时间

        this.beginTime = LDate;
        this.endTime = nowDate;

        for(let i = 30; i >= 0; i--){
            let date = new Date();
            let _date = new Date(date - 1000 * 60 * 60 * 24 * i);//最后30天可以更改，意义：是获取多少天前的时间
            let y = _date.getFullYear();
            let m = _date.getMonth()+1;
            let d = _date.getDate();
            let day = y + "-" + (m < 10 ? "0" + m : m) + "-" +(d < 10 ? "0" + d : d);//得到30天前的时间
            this.timeArr.push(day);
        }
    },
    getEchartData(){
      this.getEchartStatus = false;
      this.tableTit = '';
      this.tableDepId = '';
      this.currentPage = 1,
      this.tableListArr = [];
      if(this.top_echart){
        this.top_echart.clear();
      }
      if(this.bot_echart){
        this.bot_echart.clear();
      }
      let dataObj = {
            type: 'get',
            url: '/mcbw/dep_stats/trent/staDate/count',
            obj: {
                "pageSize":100,
                "currentPage":1,
                "areaId": this.areaId || "",
                "dataType": this.industId || "",
                "beginDate": this.beginTime,
                "endDate": this.endTime,
            }
        }
        this.$Axios(dataObj).then((res)=>{
            console.log(res);
            console.log('获取左下数据');
            if(res.data.success){
                //处理数据
                Object.keys(res.data.data).forEach((item,index)=>{
                    let arr = [];
                    for(let i = 0;i < this.timeArr.length; i++){
                        let _itemI = '';
                        for(let k = 0; k < res.data.data[item].length; k++){
                            if(res.data.data[item][k].staDate == this.timeArr[i]){
                                _itemI = k;
                                break;
                            }
                        }
                        if(_itemI !== ''){
                            arr[i] = res.data.data[item][_itemI];
                        }else{
                            arr[i] = {
                                count: 0,
                                staDate: this.timeArr[i],
                            }
                        }
                    }
                    res.data.data[item] = arr;
                });
                this.echartData = res.data.data;
                this.topInit(this.echartData);
                this.sectorInit(this.echartData, 'all');
            }
            
        }).catch((res)=>{
            this.ani_status_bot = false;
        });
    },
    topInit(data, type='line') {
        let seriesArr = [];
        Object.keys(data).forEach((item)=>{
            let obj = {};
            if(item == 'flamingFire'){ //火警
                obj = {
                    type: type,
                    name: "火警",
                    data: data[item].map((item)=>{
                        return item.count;
                    }),
                    showSymbol:false,
                    itemStyle: {
                        normal: {
                            color: '#CC0000',
                            lineStyle: {
                                width: 3,  //线条粗
                                type: "solid",
                                color: '#CC0000'
                            }
                        }
                    }, 
                    symbolSize: 5, 
                    // areaStyle: {},
                };
                seriesArr[0] = obj;
            }
            if(item == 'fire'){ //报警
                obj = {
                    type: type,
                    name: "报警",
                    data: data[item].map((item)=>{
                        return item.count;
                    }),
                    showSymbol:false,
                    itemStyle: {
                        normal: {
                            color: '#ff0000',
                            lineStyle: {
                                width: 3,
                                type: "solid",
                                color: '#ff0000'
                            }
                        }
                    }, 
                    symbolSize: 5, 
                    // areaStyle: {},
                };
                seriesArr[1] = obj;
            }
            if(item == 'warn'){ //预警
                obj = {
                    type: type,
                    name: "预警",
                    data: data[item].map((item)=>{
                        return item.count;
                    }),
                    showSymbol:false,
                    itemStyle: {
                        normal: {
                            color: '#FF6600',
                            lineStyle: {
                                width: 3,
                                type: "solid",
                                color: '#FF6600'
                            }
                        }
                    }, 
                    symbolSize: 5, 
                    // areaStyle: {},
                };
                seriesArr[2] = obj;
            }
            if(item == 'hiddenHazard'){ //隐患
                obj = {
                    type: type,
                    name: "隐患",
                    data: data[item].map((item)=>{
                        return item.count;
                    }),
                    showSymbol:false,
                    itemStyle: {
                        normal: {
                            color: '#FFFF99',
                            lineStyle: {
                                width: 3,
                                type: "solid",
                                color: '#FFFF99'
                            }
                        }
                    }, 
                    symbolSize: 5, 
                    // areaStyle: {},
                };
                seriesArr[3] = obj;
            }
            if(item == 'fault'){ // 故障
                obj = {
                    type: type,
                    name: "故障",
                    data: data[item].map((item)=>{
                        return item.count;
                    }),
                    showSymbol:false,
                    itemStyle: {
                        normal: {
                            color: '#FFCC00',
                            lineStyle: {
                                width: 3,
                                type: "solid",
                                color: '#FFCC00'
                            }
                        }
                    }, 
                    symbolSize: 5, 
                    // areaStyle: {},
                };
                seriesArr[4] = obj;
            }
        });

        let that = this;
        let option = {
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    type: "cross"
                },
                backgroundColor:"rgba(50, 50, 50, .7)",
                borderColor:"rgba(50, 50, 50, 1)",
                textStyle:{
                  color:"#FFFFFF"
                },
              confine: true
            },
            legend: {
                data: ['火警', '报警', '预警', '隐患', '故障'],
                top: '12%',
                textStyle: {
                    color: this.echarts_color
                },
                icon: 'roundRect',
            },
            grid: {
                left: "6%",
                right: "4%",
                bottom: "20%",
                top: "30%",
                containLabel: true
            },
            xAxis: [
                {
                    type: "category",
                    boundaryGap: false,
                    axisLine: {
                      show: true,
                      lineStyle: {
                        color: "#122856",
                      }
                    },
                    data: this.timeArr,
                    axisLabel: {
                        textStyle: {
                            color: this.echarts_color
                        }
                    }
                }
            ],
            yAxis: [
                {
                    minInterval:1,
                    type: "value",
                    axisLine: {
                      show: true,
                      lineStyle: {
                        color: "#06122c",
                      }
                    },
                    axisLabel: {
                        textStyle: {
                            color: this.echarts_color
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#122856',
                        }
                    }
                }
            ],
            dataZoom: [{ //滚动条
                startValue : 12,
                endValue : 24,
                type: 'slider',
                show: true,
                xAxisIndex: [0],
                handleSize: 0,//滑动条的 左右2个滑动条的大小
                height: 10,//组件高度
                bottom: '2%',
                borderColor: "#000",
                fillerColor: '#269cdb',
                borderRadius:10,
                backgroundColor: '#33384b',//两边未选中的滑动条区域的颜色
                showDataShadow: false,//是否显示数据阴影 默认auto
                showDetail: false,//即拖拽时候是否显示详细数值信息 默认true
                realtime:true, //是否实时更新
                filterMode: 'filter',
            }],
            series: seriesArr
        };
        this.top_echart = this.$echarts.init(this.$refs.echart);
        this.top_echart.setOption(option);
        this.top_echart.off('click');
        this.top_echart.on('click',function (params) {
            that.echartClickTime = params.name;
            that.echartDay = that.timeArr[params.dataIndex];
            let dataIndex = that.timeArr.indexOf(params.name);
            let serieArr = [];
            serieArr[0] = {
                value: seriesArr[0]['data'][dataIndex],
                name: '火警',
                itemStyle: {
                    normal: {
                        color: '#CC0000',
                    }
                }, 
            }
            serieArr[1] = {
                value: seriesArr[1]['data'][dataIndex],
                name: '报警',
                itemStyle: {
                    normal: {
                        color: '#ff0000',
                    }
                }, 
            }
            serieArr[2] = {
                value: seriesArr[2]['data'][dataIndex],
                name: '预警',
                itemStyle: {
                    normal: {
                        color: '#FF6600',
                    }
                }, 
            }
            serieArr[3] = {
                value: seriesArr[3]['data'][dataIndex],
                name: '隐患',
                itemStyle: {
                    normal: {
                        color: '#FFFF99',
                    }
                }, 
            }
            serieArr[4] = {
                value: seriesArr[4]['data'][dataIndex],
                name: '故障',
                itemStyle: {
                    normal: {
                        color: '#FFCC00',
                    }
                }, 
            }
            that.currentPage = 1,
            that.tableListArr = [];
            //显示这一天的所有状态数据
            that.sectorInit(serieArr, 'day');
            this.beginDate=that.echartClickTime;
            this.endDate=that.echartClickTime;
            that.sectorTit = '火警';
        });
    },
    //饼状图点击恢复
    fanEchart(){
        this.echartfan=false;
        this.currentPage = 1,
        this.tableListArr = [];
        if(this.echartClickTime){
            this.beginDate=this.echartClickTime;
            this.endDate=this.echartClickTime;
            this.sectorTit = '火警';
            this.getTableData('flamingFire', 'all');
        }else{
            this.beginDate=this.beginTime;
            this.endDate=this.endTime;
            this.sectorTit = '火警';
            this.sectorInit(this.echartData, 'all');
        }

    },
    allEchart(){
        this.echartClickTime="";
        this.echartfan=false;
        this.echartDay = '';
        this.currentPage = 1,
        this.tableListArr = [];
        this.sectorTit = '火警';
        this.sectorInit(this.echartData, 'all');
    },
    sectorInit(data, type = 'all'){ //扇形图表初始化
        if(this.bot_echart){
            this.bot_echart.clear();
        }
        let serieArr = [];
        if(type == 'all'){ //显示所有数据
            let count0 = 0,
                count1 = 0,
                count2 = 0,
                count3 = 0,
                count4 = 0;
            for(let i = 0;i < this.timeArr.length; i++){
                count0 += data.flamingFire[i].count; // 火警
                count1 += data.fire[i].count; // 报警
                count2 += data.warn[i].count; // 预警
                count3 += data.hiddenHazard[i].count; // 隐患
                count4 += data.fault[i].count; // 故障
            }
            serieArr[0] = {
                value: count0,
                name: '火警',
                itemStyle: {
                    normal: {
                        color: '#CC0000',
                    }
                }, 
            }
            serieArr[1] = {
                value: count1,
                name: '报警',
                itemStyle: {
                    normal: {
                        color: '#ff0000',
                    }
                }, 
            }
            serieArr[2] = {
                value: count2,
                name: '预警',
                itemStyle: {
                    normal: {
                        color: '#FF6600',
                    }
                }, 
            }
            serieArr[3] = {
                value: count3,
                name: '隐患',
                itemStyle: {
                    normal: {
                        color: '#FFFF99',
                    }
                }, 
            }
            serieArr[4] = {
                value: count4,
                name: '故障',
                itemStyle: {
                    normal: {
                        color: '#FFCC00',
                    }
                }, 
            }
        }else{ //某一天数据
            serieArr = data;
        }
        let option = {
            tooltip: {
                trigger: 'item',
                backgroundColor:"rgba(50, 50, 50, .7)",
                borderColor:"rgba(50, 50, 50, 1)",
                textStyle:{
                  color:"#FFFFFF"
                },
                formatter: '{a} <br/>{b} : {c} ({d}%)'
            },
            series: [
                {
                    name: '数量',
                    type: 'pie',
                    radius: '50%',
                    center: ['50%', '70%'],
                    data: serieArr,
                }
            ]
        }
        console.log(option);
        let that = this;
        this.bot_echart = this.$echarts.init(this.$refs.sectorEchart);
        this.bot_echart.setOption(option);
        this.bot_echart.off('click');
        this.bot_echart.on('click',function (params) {
            that.echartfan=true;
            let dataType = '';
            switch (params.name) {
                case '火警':
                    that.sectorTit = '火警';
                    dataType = 'flamingFire';
                    break;
                case '报警':
                    that.sectorTit = '报警';
                    dataType = 'fire';
                    break;
                case '预警':
                    that.sectorTit = '预警';
                    dataType = 'warn';
                    break;
                case '隐患':
                    that.sectorTit = '隐患';
                    dataType = 'hiddenHazard';
                    break;
                case '故障':
                    that.sectorTit = '故障';
                    dataType = 'fault';
                    break;
            }
            that.currentPage = 1,
            that.tableListArr = [];
            if(type == 'all'){
                this.beginDate=this.beginTime;
                this.endDate=this.endTime;
            }else{
                this.beginDate=this.echartClickTime;
                this.endDate=this.echartClickTime;
            }
            that.getTableData(dataType, type, 'noWhole');
        });
        if(type == 'all'){
            this.beginDate=this.beginTime;
            this.endDate=this.endTime;
        }else{
            this.beginDate=this.echartClickTime;
            this.endDate=this.echartClickTime;
        }
        //默认取火警数据
        this.getTableData('flamingFire', 'all');
    },
    getTableData(dataType = 'flamingFire', timeType='all', botClick=''){
        this.tableType = dataType;
        let dataObj = {
            type: 'get',
            url: '/mcbw/dep_stats/circular/depId/count',
            obj: {
                "pageSize":100,
                "currentPage":this.currentPage,
                "beginDate": this.echartDay?this.echartDay:this.beginDate,
                "endDate": this.echartDay?this.echartDay:this.endDate,
                "type": dataType,
                "areaId": this.areaId || "",
                "dataType": this.industId || "",
            }
        }
        if(timeType == 'all'){
            
            //dataObj.obj['whole'] = 'whole';
        }
        if(botClick){ //如果是底部饼图点击，不传这个参数
            delete dataObj.obj['whole'];
        }
        this.$Axios(dataObj).then((res)=>{
            console.log(res);
            console.log('table数据');
            if(res.data.success){
                if(res.data.totalCount){
                    this.totalCount = res.data.totalCount;
                }
                if(!res.data.data.length){
                    return;
                }
                this.tableListArr = [...this.tableListArr, ...res.data.data];
                let _this = this;
                this.$nextTick(()=>{
                    $JQ('#leftBot').mCustomScrollbar({
                        callbacks: {
                            onTotalScroll: function () {
                                if ((_this.tableListArr.length == res.data.totalCount) || (res.data.data.length == 0)) {
                                    console.log('没有更多数据');
                                    return;
                                } else {
                                    console.log('加载更多');
                                    _this.currentPage += 1;
                                    _this.getTableData(dataType, timeType);
                                }
                            }
                        }
                    });
                });
            }
            
        });
    }
  }
}
</script>
<style lang="scss" scoped>
.layer-tem{
    position: absolute;
    left: 500px;
    bottom: 0;
    width: calc(100% - 1000px);
    // height: 500px;
    padding: 30px 25px;
    background: rgba(6,18,44,1) url('../../assets/img/maskBg.png') center center/101% 102% no-repeat;
    z-index: 12;
    // position: relative;
    .detail-layer-wrap{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 500px;
        z-index: 1;
        padding: 30px 10px;
        background: rgba(6,18,44,1) url('../../assets/img/maskBg.png') center center/101% 102% no-repeat;
        .close-btn{
            top: 10px;
        }
        .table-wrap{
            height: 100%;
            display: flex;
            flex-direction: column;
            .table-head{
                background: #0C2745;
                color: #7DB4DB;
                table th{
                    height: 30px;
                }
            }
            .table-body{
                flex: 1;
                flex-shrink: 0;
                overflow: hidden;
                color: #E4EFF5;
                table td{
                    text-align: center;
                    height: 30px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    i{
                    cursor: pointer;
                    }
                    i.imgView {
                        color: rgba(8, 244, 247, .7);
                        cursor: pointer;
                        &.active {
                            color: rgba(8, 244, 247, .3);
                            cursor: default;
                        }
                    }
                    .td-option-wrap {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        i {
                            margin: 0 10px;
                            color: rgba(8, 244, 247, .3);
                            cursor: default;
                            &.active {
                                color: rgba(8, 244, 247, .7);
                                cursor: pointer;
                            }
                        }
                    }
                }
                table tr:nth-child(2n){
                  background: #0C2745;
                }
                .no-data{
                    height: 152px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #ddd;
                }
            }

            table{
            width: 100%;
            table-layout: fixed;
            border-collapse: collapse;
            }
        }
    }
    // 关闭按钮
    .close-btn{
        position: absolute;
        right: 0;
        top: 0;
        right: 25px;
        top: 30px;
        cursor: pointer;
    }
    .block-head{
    margin: 10px 0;
    display: flex;
    align-items: center;
    &.block-head-form{
      justify-content: space-between;
    }
    &.block-head-text{
      color: #00eef3;
      .text{
        margin-right: 20px;
      }
    }
    .tit{
      min-width: 200px;
      margin-right: 20px;
    }
  }
  .block-main{
    height: 200px;
    position: relative;
    /*padding: 8px;*/

    .block-main-content{
      height: 100%;
      position: relative;
      .time_nav_bar{
        position: absolute;
        right: 0;
        top: 5px;
        z-index: 1;
        display: flex;
        align-items: center;
        li{
          position: relative;
          padding: 0 10px;
          font-size: 14px;
          line-height: 20px;
          color: rgba(116, 217, 255, .7);
          cursor: pointer;
          &.active{
            color: rgba(116, 217, 255, 1);
          }
          &:first-child:after{
            content: "";
            position: absolute;
            right: 0;
            top: 2.5px;
            width: 1px;
            height: 15px;
            background: rgba(0, 238, 243, .7);
          }
        }
      }
      .echart{
        height: 100%;
      }
      .no-data{
        height: 184px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ddd;
      }
      &.bot-block-wrap{
        display: flex;
        .echart-wrap{
            width: 300px;
            position: relative;
            .echart-head{
                display: flex;
                align-items: center;
                justify-content: space-between;
                position: absolute;
                left: 0;
                top: 0px;
                width: 100%;
                /*padding: 0 10px;*/
                z-index: 1;
                .echart-tit{
                    text-align: left;
                    p{
                        width: 235px;
                        font-size: 16px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #A2D8FF;
                    }
                }
            }
            .sector-echart{
                height: 100%;
            }
        }
        .table-wrap{
            flex: 1;
            overflow: hidden;
        }
      }
      
      .table-wrap{
        height: 100%;
        display: flex;
        flex-direction: column;
        .table-head{
            background: #0C2745;
            color: #7DB4DB;
            font-family: Microsoft YaHei;
            font-weight: 400;
            table th{
                height: 37px;
            }
        }
        .table-body{
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
            color: #E4EFF5;
            table td{
                text-align: center;
                height: 37px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-family: Microsoft YaHei;
                font-weight: 400;
                i{
                cursor: pointer;
                }
                i.imgView {
                    color: #7DB4DB;
                    opacity: 0.5;
                    cursor: pointer;
                    &.active {
                        opacity: 1;
                        cursor: default;
                    }
                }
                .td-option-wrap {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    i {
                        margin: 0 10px;
                        color: #7DB4DB;
                        opacity: 0.5;
                        cursor: default;
                        &.active {
                            opacity: 1;
                            cursor: pointer;
                        }
                    }
                }
            }
            table tr:nth-child(2n){
              background: #0C2745;
            }
            .no-data{
                height: 152px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #ddd;
            }
        }

        table{
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/layer/leftBot.vue